/**
 * Base64-encodes a TWRN and makes the result URL-safe so it can be used as a
 * single path segment (e.g. Hub profile deep links: `/profiles/{encodedTwrn}`).
 *
 * Produces standard base64url: `+` -> `-`, `/` -> `_`, and trailing `=` padding
 * removed. See the "Deep Linking to Hub Profiles via TWRN" platform doc and HUB-11661.
 */
export function encodeTwrn(twrn: string): string {
	return btoa(twrn)
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
		.replace(/=+$/g, '');
}
